/* eslint-disable @typescript-eslint/no-explicit-any */

const SearchStatus = {
  BEFORE: 0,
  EDITING: 1,
  NONE: 2
};

export { SearchStatus };
